import React, { ReactElement } from 'react';
import IconProps from '../IconProps';

export default function IconNotification({
    color = '#fff',
    className,
    ariaHidden = false,
    size = 20,
}: IconProps): ReactElement {
    return (
        <svg
            width={size}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
            aria-hidden={ariaHidden}
            viewBox='0 0 16 20'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8 0a1 1 0 0 1 1 1v.778c3.286.418 6 2.868 6 6.08v6.669l.932 2.396A1 1 0 0 1 15 18.286h-4.204C10.338 19.348 9.173 20 8 20c-1.173 0-2.338-.652-2.796-1.714H1a1 1 0 0 1-.932-1.363L1 14.527V7.836l.004-.193.001-.022C1.138 4.524 3.795 2.185 7 1.778V1a1 1 0 0 1 1-1ZM6.017 16.286H2.462l.47-1.21A1 1 0 0 0 3 14.715V7.868l.004-.17C3.1 5.613 5.164 3.713 8 3.713c2.912 0 5 1.994 5 4.143v6.857c0 .124.023.247.068.363l.47 1.209h-3.521a.952.952 0 0 0-.034 0H6.017Z'
                fill={color}
            />
        </svg>
    );
}
